function support(state={
    fetching : false,
    putting : false,
    deleting : false,
    posting : false,
    data : {},
}, action) {
    let newData;
    let newKindData;
    switch(action.type) {
        case 'FETCH_SUPPORT_ITEMS_START':
            return {
                ...state,
                fetching : true,
            }
        case 'FETCH_SUPPORT_ITEMS_SUCCESS':
            return {
                ...state,
                fetching : false,
                data : action.data,
            }
        case 'FETCH_SUPPORT_ITEMS_FAILURE':
            return {
                ...state,
                fetching : false,
            }
        case 'DELETE_SUPPORT_ITEM_START':
            return {
                ...state,
                deleting : true,
                deleteError : null,
            }
        case 'DELETE_SUPPORT_ITEM_SUCCESS':
            newKindData = [];
            for(let i=0; i<state.data[action.item.kind].length; i++) {
                const item = state.data[action.item.kind][i];
                if(item.id !== action.item.id) {
                    newKindData.push(item);
                }
            }
            return {
                ...state,
                deleting : false,
                data : {
                    ...state.data,
                    [action.item.kind] : newKindData
                },
            }
        case 'DELETE_SUPPORT_ITEM_FAILURE':
            return {
                ...state,
                deleting : true,
                deleteError : action.error,
            }
        case 'STORE_SUPPORT_ITEM_START' :
            return {
                ...state,
                xhr : action.xhr,
                editedItem : action.editedItem,
                posting : true,
            }
        case 'STORE_SUPPORT_ITEM_SUCCESS' :
            if(state.editedItem) {
                newData = findAndReplaceOldItem(state.data, state.editedItem, action.item);
            } else {
                newData = {
                    ...state.data,
                    [action.item.kind] : [
                        ...state.data[action.item.kind],
                        action.item
                    ]
                }
            }
            return {
                ...state,
                xhr : null,
                progress : 0,
                posting : false,
                data : newData,
            }
        case 'STORE_SUPPORT_ITEM_FAILURE' :
            return {
                ...state,
                progress : 0,
                xhr : null,
                posting : false,
            }
        case 'STORE_SUPPORT_ITEM_PROGRESS' :
            return {
                ...state,
                progress : action.progress,
            }
        default :
            return state;
    }
}

function findAndReplaceOldItem(data, oldItem, newItem) {
    if(oldItem.kind !== newItem.kind) {
        let oldData = [];
        let newData = data[newItem.kind] || [];
        for(let i=0; i< (data[oldItem.kind] || []).length; i++) {
            const item = data[oldItem.kind][i];
            if(item.id !== oldItem.id) {
                oldData.push(item);
            }
        }
        return {
            ...data,
            [oldItem.kind] : oldData,
            [newItem.kind] : [
                ...newData,
                newItem
            ]
        }
    }else {
        let newData = [];
        for(let i=0; i< data[newItem.kind].length; i++) {
            const item = data[newItem.kind][i];
            if(item.id === newItem.id) {
                newData.push(newItem);
            }else {
                newData.push(item);
            }
        }
        return {
            ...data,
            [newItem.kind] : newData
        }
    }
}

export default support;


/** WEBPACK FOOTER **
 ** ./src/reducers/support.js
 **/